module.exports = __webpack_public_path__ + "static/img/loging.d8654aa.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/login/loging.gif
// module id = q5Ol
// module chunks = 1